import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Body, Heading } from "@hypercard/web-components";
import { Bank } from "@phosphor-icons/react";
import { useTransition, easings, animated } from "@react-spring/web";
import { useSkipConnectBankAccount } from "./hooks";
import { useNavigate } from "react-router-dom";
import BlurredLightEffect from "./BlurredLightEffect";

const AnimatedCard = animated(Card);

// @TODO Abstract reusable styling and logic into a Banner component when there
// is a second use case for this design/behavior.

export const AddBankAccountBanner = () => {
  const navigate = useNavigate();
  const { skipConnectBankAccount, showConnectBankAccountBanner } =
    useSkipConnectBankAccount();

  // react-spring useTransition only accepts an array as first argument
  // using an array of one truthy value allows us to use enter and leave transitions
  const transitions = useTransition(
    showConnectBankAccountBanner ? [true] : [],
    {
      enter: { opacity: 1, maxHeight: "100%" },
      leave: { opacity: 0.5, maxHeight: "0%" },
      from: { opacity: 0.5, maxHeight: "0%" },
      config: { duration: 300, easing: easings.linear },
    },
  );

  const addPersonalAccount = () => {
    navigate("/settings/bank-account");
  };

  return transitions((style, item) => (
    <AnimatedCard
      key={`banner--item-${item}`}
      style={style}
      className="relative mt-6 w-full overflow-hidden p-8"
    >
      <BlurredLightEffect variant="top-left" />
      <BlurredLightEffect variant="bottom-right" />
      <Bank className="absolute right-[-59px] top-[-120px] h-[470px] w-[470px] fill-white/5 stroke-[rgba(255,255,255,0.09)]" />
      <Heading size="lg" weight="regular">
        No bank account added
      </Heading>
      <Body size="md" weight="regular" className="mt-2 text-white/70">
        Connect your personal bank account to receive reimbursements from your
        company.
      </Body>
      <div className="mt-4 flex gap-2">
        <Button onClick={addPersonalAccount}>Add Personal Account</Button>
        <Button variant="ghost" onClick={skipConnectBankAccount}>
          Skip for now
        </Button>
      </div>
    </AnimatedCard>
  ));
};
